import React from 'react'


export default function Checkout({item}) {

    


    return (
        <div className='w-full text-center bg-dwam'>
           
            <div className='flex justify-between p-2'>
                <p>{item.Ptitle}</p>
                <p>{item.price}$</p>
            </div>
        
        </div>
    )
}
